import { AxiosResponse } from "axios";
import { APIClient } from "../axiosClient";
import { PaginationResponse, ResponseData } from "../types/_public";
import {
  ITrendIndex,
  ICategoryTrendIndex,
  TrendIndexCategory,
} from "../types/newshub/_trendIndex";
import { PATH_NEWSHUB_API } from "helpers/newshub/constans";
const api = new APIClient();

const path_trend_index = PATH_NEWSHUB_API + '/trend-index';

const trendIndexApi = {
  categories(
    params: any
  ): Promise<
    AxiosResponse<ResponseData<ICategoryTrendIndex[]> & PaginationResponse, any>
  > {
    const url = `${PATH_NEWSHUB_API}/categories`;
    return api.get(url, { ...params, type: "trend_index" });
  },
  trendIndexes(
    params: any
  ): Promise<
    AxiosResponse<ResponseData<ITrendIndex[]> & PaginationResponse, any>
  > {
    const url = `${path_trend_index}/keywords`;
    return api.get(url, params);
  },
  searchCategories(
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<ICategoryTrendIndex[]>, any>> {
    const url = `${PATH_NEWSHUB_API}/masters/categories`;
    return api.get(url, params);
  },
  relatedKeywords(
    params: any
  ): Promise<
    AxiosResponse<ResponseData<ITrendIndex[]> & PaginationResponse, any>
  > {
    const paramsClone = structuredClone(params);
    delete paramsClone.id;
    const url = `${PATH_NEWSHUB_API}/keywords/${params?.id}/related`;
    return api.get(url, paramsClone);
  },
  deleteTrendIndex(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<ITrendIndex>, any>> {
    const url = `${path_trend_index}/${id}`;
    return api.delete(url, dataForm);
  },
  deleteMultiplesTrendIndex(
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<ITrendIndex>, any>> {
    const url = `${path_trend_index}`;
    return api.delete(url, { data: dataForm });
  },
  deleteCategoryTrendIndex(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<ICategoryTrendIndex>, any>> {
    const url = `${PATH_NEWSHUB_API}/categories/${id}`;
    return api.delete(url, dataForm);
  },
  postAnalysis(
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<ITrendIndex>, any>> {
    const url = `${PATH_NEWSHUB_API}/analysis`;
    return api.post(url, dataForm);
  },
  putTrendIndexCategory(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<TrendIndexCategory>, any>> {
    const url = `${PATH_NEWSHUB_API}/categories/${id}`;
    return api.put(url, dataForm);
  },
};
export default trendIndexApi;
